import Vue from 'vue'

function list (params = {}) {
  const path = '/admin/users'
  return Vue.api.get(path, { params })
}

export default { list }
